import React, { useEffect, useId } from 'react';
const JOTFORM_ID = '262502459177057';
const JOTFORM_ORIGIN = 'https://form.jotform.com/';
const HANDLER_SRC = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
declare global {
  interface Window {
    jotformEmbedHandler?: (selector: string, origin: string) => void;
  }
}
let handlerPromise: Promise<void> | null = null;
function loadEmbedHandler(): Promise<void> {
  if (typeof window === 'undefined' || window.jotformEmbedHandler) {
    return Promise.resolve();
  }
  if (!handlerPromise) {
    handlerPromise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = HANDLER_SRC;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('JotForm embed handler failed to load'));
      document.body.appendChild(script);
    });
  }
  return handlerPromise;
}
interface ConsultationFormProps {
  id?: string;
  title: string;
}
export function ConsultationForm({
  id,
  title
}: ConsultationFormProps) {
  const reactId = useId();
  const iframeId = `JotFormIFrame-${JOTFORM_ID}-${reactId.replace(/[^a-zA-Z0-9]/g, '')}`;

  // The handler script listens for the form's postMessage events and resizes the
  // iframe as fields expand or validation messages appear.
  useEffect(() => {
    let cancelled = false;
    loadEmbedHandler().then(() => {
      if (cancelled) return;
      window.jotformEmbedHandler?.(`iframe[id='${iframeId}']`, JOTFORM_ORIGIN);
    }).catch(() => {
      // The form still renders and submits without the resize handler.
    });
    return () => {
      cancelled = true;
    };
  }, [iframeId]);
  return <div id={id} className="rounded-2xl bg-white p-4 shadow-xl sm:p-6" data-id="element-7" data-mp="30w3yx39us6l7">
      <h3 className="px-2 pt-2 font-display text-2xl text-brand-charcoal sm:text-3xl" data-id="element-8" data-mp="l57yqm06ahu9">{title}</h3>
      <iframe id={iframeId} title={title} src={`https://form.jotform.com/${JOTFORM_ID}`} allow="geolocation; microphone; camera; fullscreen; payment" allowTransparency scrolling="no" className="mt-3 w-full border-none" style={{
      minWidth: '100%',
      maxWidth: '100%',
      height: 539
    }} data-id="element-9" data-mp="g7655754f04j" />
    </div>;
}